import { createContext, Ref } from 'react';
import { FormBuilderProps } from '../types';

const FormBuilderContext = createContext<
  {
    setFormError?: (error: Error) => void;
    color?: string;
    formRef?: Ref<HTMLFormElement>;
  } & FormBuilderProps
>({});

export default FormBuilderContext;
